import React, { useState, useEffect, useRef } from 'react'
import Select from 'react-select'
import Modal from "./modal"
import moment from "moment"
import { CalendarToday } from '@material-ui/icons';

export const Search_Panel = ({ startDate, setStartDate, endDate, setEndDate, type, SelectType, setSelectType, setPage }) => {
    const DateRangeRef = useRef(null)
    const [modal, setModal] = useState(false)
    const [width, setWidth] = useState(window.innerWidth)

    const SetWid = () => {
        setWidth(window.innerWidth)
    }

    useEffect(() => {
        window.addEventListener("resize", SetWid)
        return () => {
            window.removeEventListener("resize", SetWid)
        }
    })

    return (

        <div className="row" id="suck" >
            <div className="col-12 col-md">

                <div ref={DateRangeRef} id="datepicker" style={{ border: '1px solid hsl(0, 0%, 80%)', height: '38px', borderRadius: '4px', cursor: 'pointer' }} onClick={() => { setModal(true) }}>
                    <div style={{ height: '100%', float: 'left' }}> <span style={{ lineHeight: '38px', verticalAlign: 'middle' }}>{moment(startDate).format("DD-MMM-YYYY")}</span> {endDate && <span>- {moment(endDate).format("DD-MMM-YYYY")}</span>}</div>
                    <div style={{ height: '100%', float: 'right' }}><CalendarToday style={{ height: '38px' }} /> </div>
                </div>
                {modal && <Modal modalIsOpen={modal} setIsOpen={setModal} start={startDate} end={endDate} setDate={setStartDate} setEnd={setEndDate} />}
            </div>
            <div className={`col-12 col-md-12 col-lg-6 col-xl-6 ${width >= 0 && width <= 992 ? 'mt-2 ml-1' : ""}`}>
                <Select options={type} noOptionsMessage={() => "No Data!"} value={SelectType && type[type.findIndex(v => v.value === SelectType)]} placeholder="Request type..." onChange={(values) => {
                    setSelectType(values?.value)
                    localStorage.setItem("Type", values?.value)
                    setPage && setPage(0)

                }} isClearable />
            </div>
        </div>
    )
}